<app-images-tab-for-products
  #imagesTabsComponent
  [type]="type"
  [specParent]="packagingUnitId"
  [maxImagesCount]="(isSecondaryProduct$ | async) ? 1 : 3"
></app-images-tab-for-products>
